/**
 * 创建人：张丽莉
 * 时间：2019-12-17
 * 描述：innerHtml内的内容可以显示片段中的样式
 * 更新记录: 
 */
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {
  //获取当前dom节点
  constructor(private dom: DomSanitizer){}
  /**
   * 管道的初始化方法
   * @param value 传入的数据 为标签字符串
   */
  transform(value): any {
    return this.dom.bypassSecurityTrustHtml(value);
  }
}
